import {getApiParticipants, getApiTopics} from 'reduxes/slices/api/selectors'
import {createSelector} from 'reselect'

import {getCurrentHandle} from '../current/selectors'

export const getApiDirectChats = createSelector(
    [getApiTopics],
    (topics) => {
        return (
            topics &&
            Object.values(topics).filter(
                (topic) => topic.participant_mode === 'direct_chat',
            )
        )
    },
)

export const getDirectChatsByHandles = createSelector(
  [getApiDirectChats, getCurrentHandle],
  (directChats, currentHandle) => {
    const newObj = {}
    directChats.forEach((chat) => {
      const other_handle = chat.contact_handles.find(
        (element) => element !== currentHandle,
      )
      newObj[other_handle] = chat
    })
    return newObj
  },
)

export const getApiPersonalChat = createSelector(
  [getApiTopics],
  (topics) => {
    return (
      topics &&
      Object.values(topics).filter(
        (topic) => topic.participant_mode === 'personal',
      )[0]
    )
  },
)

export const makeGetDirectChatTopicFromHandle = () =>
  createSelector(
    [
      getApiDirectChats,
      getApiPersonalChat,
      getCurrentHandle,
      (_, props) => props.handle,
    ],
    (directChats, personalChat, currentHandle, handle) => {
      if (handle === currentHandle) {
        return personalChat
      } else {
        return Object.values(directChats).find((chat) => {
          return chat.contact_handles.includes(handle)
        })
      }
    },
  )

export const getTopicIdLookup = createSelector(
  [getApiDirectChats, getApiPersonalChat, getCurrentHandle],
  (directChats, personalChat, currentHandle) => {
    const lookup = Object.values(directChats).reduce((acc, directChat) => {
      const handle = directChat.contact_handles.filter(
        (handle) => handle !== currentHandle,
      )[0]
      acc[handle] = directChat.id
      return acc
    }, {})
    return {
      ...lookup,
      ...(personalChat ? { [currentHandle]: personalChat.id } : {}),
    }
  },
)

export const getUnreadDirectChats = createSelector(
  [getApiDirectChats, getCurrentHandle, getApiParticipants],
  (directChats, currentHandle, participants) => {
    const allChats = []
    Object.values(directChats).forEach((chat) => {
      if (chat.contact_handles.indexOf(currentHandle) > -1) {
        allChats.push(chat)
      }
    })

    const allParticipants = Object.values(participants)
    const unread = []

    allChats.forEach((c) => {
      const badge = allParticipants.find(
        (p) =>
          p.handle === currentHandle &&
          p.parent_type === 'Topic' &&
          p.parent_id === c.id,
      )?.badge

      // If there's no badge for this chat, ignore it
      if (!badge) {
        return
      }

      const participantHandle = c.contact_handles.find(
        (o) => o !== currentHandle,
      )
      const participant = allParticipants.find(
        (p) =>
          p.handle === participantHandle &&
          p.parent_type === 'Topic' &&
          p.parent_id === c.id,
      )

      if (!participant) {
        return
      }

      unread.push({
        id: c.id,
        handle: participant.handle,
        account_name: participant.account_name || participant.name_from_handle,
        badge: badge,
      })
    })

    return unread
  },
)
